import React from 'react';
import './styles.css';
import { formatDateFromInstant } from 'app/shared/util/date-utils';
import LazyTable from 'app/component/lazy-table';

const ProvisionSheetGroupTable: React.FC = () => {
  return LazyTable({
    initialSortField: 'id',
    initialSortDirection: 'desc',
    createUrl: '/',
    serverUrl: '/api/provision-sheet-groups',
    editActionAllowed: false,
    deleteActionAllowed: true,
    searchAllowed: false,
    globalFilterFields: ['name', 'insuranceCompany.name', 'productType.name'],
    columns: [
      { field: 'id', header: 'ID', sortable: true },
      { field: 'createdDate', header: 'Vygenerované', sortable: true, formatter: formatDateFromInstant },
      { field: 'nrOfVisibleSheets', header: 'Zobrazené provízne listy' },
      { field: 'nrOfInvisibleSheets', header: 'Skryté provízne listy ' },
    ],
  });
};

export default ProvisionSheetGroupTable;
